function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  version: "1.1",
  id: "Ebene_1",
  x: "0",
  y: "0",
  viewBox: "-70 61.5 141.7 18.2",
  xmlSpace: "preserve"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "g3786",
  stroke: "#fcfcfc",
  strokeWidth: ".405",
  strokeMiterlimit: "0",
  strokeDasharray: "none",
  strokeOpacity: "1",
  paintOrder: "markers stroke fill"
}, /*#__PURE__*/React.createElement("g", {
  id: "g3776"
}, /*#__PURE__*/React.createElement("path", {
  className: styles["st0"] || "st0",
  d: "M-19.5 70.1h4.1c2 0 2 1.1 1.7 1.9-.3.8-.8 1.2-1.4 1.5.6.2 1 .8.6 1.9-.5 1.5-2.1 2.3-3.4 2.3h-4.2zm.3 5.7h1.4c.5 0 .9-.1 1.2-.7.2-.4 0-.7-.6-.7h-1.4zm1-2.8h1.2c.5 0 .8-.1 1-.6.1-.4-.1-.5-.6-.5h-1.2z",
  id: "path3756",
  fill: "#fb0",
  stroke: "#fcfcfc",
  strokeWidth: ".405",
  strokeMiterlimit: "0",
  strokeDasharray: "none",
  strokeOpacity: "1",
  paintOrder: "markers stroke fill"
}), /*#__PURE__*/React.createElement("path", {
  className: styles["st0"] || "st0",
  d: "M-11.6 70.1h6.2l-.7 1.9H-10l-.3.9h3.5l-.6 1.8h-3.5l-.3.9h4l-.7 1.9h-6.3z",
  id: "path3758",
  fill: "#fb0",
  stroke: "#fcfcfc",
  strokeWidth: ".405",
  strokeMiterlimit: "0",
  strokeDasharray: "none",
  strokeOpacity: "1",
  paintOrder: "markers stroke fill"
}), /*#__PURE__*/React.createElement("path", {
  className: styles["st0"] || "st0",
  d: "M-3.2 72h-2.1l.7-1.9h6.5L1.2 72H-.9l-2 5.6h-2.3z",
  id: "path3760",
  fill: "#fb0",
  stroke: "#fcfcfc",
  strokeWidth: ".405",
  strokeMiterlimit: "0",
  strokeDasharray: "none",
  strokeOpacity: "1",
  paintOrder: "markers stroke fill"
}), /*#__PURE__*/React.createElement("path", {
  className: styles["st0"] || "st0",
  d: "M4 70.1h2.3l.1 7.5H3.9l.1-1.1H1.6l-.7 1.1h-2.3zm.1 4.8l.1-2.3v0l-1.5 2.3z",
  id: "path3762",
  fill: "#fb0",
  stroke: "#fcfcfc",
  strokeWidth: ".405",
  strokeMiterlimit: "0",
  strokeDasharray: "none",
  strokeOpacity: "1",
  paintOrder: "markers stroke fill"
}), /*#__PURE__*/React.createElement("path", {
  className: styles["st1"] || "st1",
  d: "M9.6 70.1h5.8l-.7 1.9h-3.5l-.3.9h3l-.6 1.8h-3l-1 2.9H7z",
  id: "path3764",
  fill: "#424242",
  stroke: "#fcfcfc",
  strokeWidth: ".405",
  strokeMiterlimit: "0",
  strokeDasharray: "none",
  strokeOpacity: "1",
  paintOrder: "markers stroke fill"
}), /*#__PURE__*/React.createElement("path", {
  className: styles["st1"] || "st1",
  d: "M16.3 70.1h2.3l-2 5.6h3.3l-.7 1.9h-5.6z",
  id: "path3766",
  fill: "#424242",
  stroke: "#fcfcfc",
  strokeWidth: ".405",
  strokeMiterlimit: "0",
  strokeDasharray: "none",
  strokeOpacity: "1",
  paintOrder: "markers stroke fill"
}), /*#__PURE__*/React.createElement("path", {
  className: styles["st1"] || "st1",
  d: "M22.7 70.1H25l-2.7 7.5H20z",
  id: "path3768",
  fill: "#424242",
  stroke: "#fcfcfc",
  strokeWidth: ".405",
  strokeMiterlimit: "0",
  strokeDasharray: "none",
  strokeOpacity: "1",
  paintOrder: "markers stroke fill"
}), /*#__PURE__*/React.createElement("path", {
  className: styles["st1"] || "st1",
  d: "M29.4 76.8c-.7.7-1.6.9-2.5.9-2.2 0-3-1.7-2.2-3.8 1-2.9 3.4-4 5.1-4 1.9 0 2.7 1 2.5 2.8h-2.2c.1-.5-.2-.9-.8-.9-1.6 0-2.1 1.7-2.3 2.2-.2.7-.4 1.9 1 1.9.5 0 1.2-.3 1.5-.8h-1l.6-1.6h3.1l-1.5 4.1h-1.5z",
  id: "path3770",
  fill: "#424242",
  stroke: "#fcfcfc",
  strokeWidth: ".405",
  strokeMiterlimit: "0",
  strokeDasharray: "none",
  strokeOpacity: "1",
  paintOrder: "markers stroke fill"
}), /*#__PURE__*/React.createElement("path", {
  className: styles["st1"] || "st1",
  d: "M34.6 70.1h2.3l-.9 2.6h2.2l.9-2.6h2.3l-2.7 7.5h-2.3l1.1-3h-2.2l-1.1 3h-2.3z",
  id: "path3772",
  fill: "#424242",
  stroke: "#fcfcfc",
  strokeWidth: ".405",
  strokeMiterlimit: "0",
  strokeDasharray: "none",
  strokeOpacity: "1",
  paintOrder: "markers stroke fill"
}), /*#__PURE__*/React.createElement("path", {
  className: styles["st1"] || "st1",
  d: "M43.6 72h-2.1l.7-1.9h6.5L48 72h-2.1l-2 5.6h-2.3z",
  id: "path3774",
  fill: "#424242",
  stroke: "#fcfcfc",
  strokeWidth: ".405",
  strokeMiterlimit: "0",
  strokeDasharray: "none",
  strokeOpacity: "1",
  paintOrder: "markers stroke fill"
})), /*#__PURE__*/React.createElement("g", {
  id: "g3784"
}, /*#__PURE__*/React.createElement("path", {
  className: styles["st0"] || "st0",
  d: "M-36.4 73.5s-2.5 1.2-1.7 3.5c.9 2.6 5.3 2.3 7.9 1.2 2.2-.9.4-1.6.4-1.6l-2.3-1.3-3.4-2.1z",
  id: "path3778",
  fill: "#fb0",
  stroke: "#fcfcfc",
  strokeWidth: ".405",
  strokeMiterlimit: "0",
  strokeDasharray: "none",
  strokeOpacity: "1",
  paintOrder: "markers stroke fill"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-30.3 75.5c-1.7-.7-2.9-1.7-4-2.2.6-.3 1.2-.7 1.6-1 .4-.4.5-.8.5-1.3 1.2.8 2.7.9 3.5.9.8 0 1.5.2 1.7.6 0 0 .2-4.2-8.4-7 0 0 2.6 1.2 3.4 2.1 0 0-.9-.1-1.3.5-.2.3-.2.8-.1 1.3-.1 0-.3 0-.5-.1l-13.7-7.6 1.4 3.1-1.4-.5.4.8s.6 1.1 1.9 3.4c1 1.8 2.9 2.7 5.4 2.6h.3c.6 0 1.6-.1 2.5-.2-.1.3-.1.7 0 1.2.1.6.3.9.6 1.2-.7.3-1.4 1-1.7 1.8 0 0 0 0 0 0v.1s0 0 0 0c-.2.5-.3 1.1 0 1.8 0 0 0 0 0 0 0 .1.1.3.2.4.1.1.2.3.3.4 1.5 1.8 5.3 1.5 7.6.5h.1l.6-.3s.1 0 .1-.1l.6-.3c2.3-1.4 3.1-2.9 3.1-2.9s-2.5 1.8-4.7.8zm.6-6.2c.7.3 1.7 1.9 1.7 1.9-.8-.1-2.5-.7-2.7-1.3-.2-.6.3-.9 1-.6zm-10.4 1.2c-.9 0-1.7-.1-2.4-.3-1-.4-1.8-1-2.3-2-.7-1.2-1.2-2-1.5-2.6l1.2.4-1.2-2.7 10.8 6c-.3 0-.6.1-.9.3l-6.9-2.8 6 3.4c-1.1.2-2.2.3-2.8.3zm2 6.2c-.1-.5-.1-.9 0-1.3.6.4 1.6.7 2.9.2.1-.1-.9 1.1-2.9 1.1zm3.2 2.2c-.4-.1-.9-.2-1.3-.3l-.6-.3c.9-.2 2-.7 3-1.9 0 0-.1 1.3-1.1 2.5zm3-.3c-.2.1-.5.1-.7.2.4-.3.8-.7.8-1.4 0 0 .2.8-.1 1.2zm3.2-1.5c-.1-.3-.2-.9-.2-.9.7.1 1.6-.2 1.6-.2-.6.6-1.4 1.1-1.4 1.1z",
  id: "path3780",
  fill: "#3a3a3a",
  stroke: "#fcfcfc",
  strokeWidth: ".405",
  strokeMiterlimit: "0",
  strokeDasharray: "none",
  strokeOpacity: "1",
  paintOrder: "markers stroke fill"
}), /*#__PURE__*/React.createElement("path", {
  className: styles["st0"] || "st0",
  d: "M-34.1 69.8s-2.5-.6-2.9 1.3c-.1.8.2 1.5.6 1.8.2-.1.5-.2 1-.2-.1 0-.3-.3-.4-.6.2 0 .4.1.6 0 0 0-.6-.2-.8-.9 0 0 0 0 0 0 .1.1.2.1.3.1 0 0-.5-.4-.1-.9.3-.3.8-.6 1.7-.6z",
  id: "path3782",
  fill: "#fb0",
  stroke: "#fcfcfc",
  strokeWidth: ".405",
  strokeMiterlimit: "0",
  strokeDasharray: "none",
  strokeOpacity: "1",
  paintOrder: "markers stroke fill"
})))));